module.exports = __webpack_public_path__ + "img/Thank Turkey.3ea83ac1.svg";